import React, { useEffect } from 'react'
import { removeAuthorizationToken } from './storage'

export const Logout: React.FC = () => {
  useEffect(() => {
    removeAuthorizationToken()
    window.location.reload()
  }, [])

  return <div className={''}></div>
}
